import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-locize-backend';
import { locizeEditorPlugin } from 'locize';
import { initReactI18next } from 'react-i18next';

// Setup i18n instance with plugins
i18n.use(Backend).use(LanguageDetector).use(initReactI18next);

// Parameters with default values
const projectId = process.env.REACT_APP_LOCIZE_PROJECT_ID || '';
const apiKey = process.env.REACT_APP_LOCIZE_API_KEY || '';
const isProduction = process.env.NODE_ENV === 'production';
const defaultNS = 'common';
const debugLocize = process.env.REACT_APP_DEBUG_LOCIZE === 'true';

// Add debug editor if needed
if (!isProduction && debugLocize) {
  i18n.use(locizeEditorPlugin({ show: true }));
}

// Initialize right away
i18n.init({
  fallbackLng: 'en',
  supportedLngs: ['en', 'fr-CA', 'nl', 'ar', 'he', 'es'],
  load: 'currentOnly',
  interpolation: { escapeValue: false },
  debug: !isProduction,
  backend: {
    projectId,
    apiKey,
    referenceLng: 'en',
  },
  saveMissing: !isProduction,
  saveMissingTo: 'all',
  updateMissing: !isProduction,
  react: {
    useSuspense: true,
    bindI18n: 'languageChanged loaded',
  },
  defaultNS,
  ns: [
    'common',
    'projects',
    'boards',
    'inbox',
    'settings',
    'auth',
    'errors',
    'forms',
    'tooltips',
    'notifications',
    'collaborate',
    'time_entries',
    'workflows',
  ],
});

export default i18n;
